import { useLazyQuery } from '@apollo/client';
import GET_CHECK_POINT_DOCUMENT_FILE_URL from '@shared/queries/getCheckPointDocumentFileUrl';
import { blobStorageUploadFile } from '@shared/services/blobStorageService';

export const useCheckPointFile = () => {
  const [getDocumentFileUrl] = useLazyQuery(GET_CHECK_POINT_DOCUMENT_FILE_URL, {
    fetchPolicy: 'network-only'
  });

  const downloadFile = async (checkPointId, fileName, isTemporary = false) => {
    const { data, error } = await getFileURL(checkPointId, fileName, isTemporary);

    if (!data || error) {
      return { hasError: true };
    }

    window.open(data.checkPointDocumentFileUrl, '_blank');
    return { hasError: false };
  };

  const uploadFile = async (file, checkPointId, fileName) => {
    const { data, error } = await getFileURL(checkPointId, fileName, true);

    if (!data || error) {
      return { hasError: true };
    }

    await blobStorageUploadFile(data.checkPointDocumentFileUrl, file);

    return { hasError: false };
  };

  const getFileURL = async (checkPointId, fileName, isTemporary) => {
    return await getDocumentFileUrl({
      variables: {
        checkPointId: checkPointId,
        fileName: fileName,
        isTemporary: isTemporary
      }
    });
  };

  return { downloadFile, uploadFile };
};
